import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const QUALIFICATION_ENDPOINTS = {
  V1: createEndpoints('v1', {
    QUALIFICATION_STATUS: '/qualification-status/',
    INSPECTOR_COMMANDS: '/inspector-commands/',
    INSPECTOR_EXECUTE_COMMAND: '/inspector-execute-command/',
  }),
} as const;
